import React from 'react'
import { BiSolidLike } from 'react-icons/bi'
import { BsGlobe2 } from 'react-icons/bs'
import { FaDollarSign } from 'react-icons/fa'
import { RiBankFill } from 'react-icons/ri'

export const ClinicDashBoard3 = () => {
    return (
        <section className=' rounded-xl w-full my-10 min-h-[80vh] p-10 bg-gradient-to-b from-white to-blue-400 flex flex-col justify-between shadow-xl'>
            <div>
                <h1 className='text-7xl font-bold'>12,360</h1>
                <h3 className='text-blue-900 font-semibold italic'>Total Bookings this week</h3>
            </div>
            <div className=' grid grid-cols-2 gap-10'>
                <div className='flex justify-around items-center bg-white rounded-xl p-5'>
                    <div className='w-fit flex flex-col items-center'>
                        <RiBankFill className='text-4xl text-blue-900' />
                        <p className='text-2xl font-semibold'>219</p>
                        <p className='text-blue-400 italic'>Total Clinics</p>
                    </div>
                </div>
                <div className='flex justify-around items-center bg-white rounded-xl p-5'>
                    <div className='w-fit flex flex-col items-center'>
                        <BsGlobe2 className='text-4xl text-blue-900' />
                        <p className='text-2xl font-semibold'>1.2Lacs</p>
                        <p className='text-blue-500 italic'>Record Transferred</p>
                    </div>
                </div>
                <div className='flex justify-around items-center bg-white rounded-xl p-5'>
                    <div className='w-fit flex flex-col items-center'>
                        <FaDollarSign className='text-4xl text-blue-900' />
                        <p className='text-2xl font-semibold'>3,60,000</p>
                        <p className='text-blue-400 italic'>weekly Transactions</p>
                    </div>
                </div>
                <div className='flex justify-around items-center bg-white rounded-xl p-5'>
                    <div className='w-fit flex flex-col items-center'>
                        <BiSolidLike className='text-4xl text-blue-900' />
                        <p className='text-2xl font-semibold'>370</p>
                        <p className='text-blue-500 italic'>Issues Solved</p>
                    </div>
                </div>
            </div>
        </section>
    )
}
